
import { defineComponent, ref, PropType, onMounted, onUnmounted} from 'vue'

import BaseElScrollbar from './BaseElScrollbar.vue'

import { OcrResult } from '@/api/ocr/type'

export default defineComponent({
  name: 'PictureList',
  components: { BaseElScrollbar },
  props: {
    pictureList: {
      type: Array as PropType<OcrResult.Res>,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  setup (props, { emit }) {
    const scrollValue = ref(0) // 记录滚动位置
    // 选中图片样式
    const checkedStyle = {
      transform: 'scale(1.03)',
      'box-shadow': 'rgb(2, 167, 240) 0px 0px 5px 1px',
      border: '1px solid #4483fa'
    }
    function changeCurrentPic (index: number) {
      emit('update:activeIndex', index)
    }
    const scrollRef = ref()
    function scrollByClick (num: number) {
      const wrap = scrollRef.value.elScrollbarRef.$refs.wrap
      wrap.scrollLeft = scrollValue.value + num
    }

    function scroll () {
      const wrap = scrollRef.value.elScrollbarRef.$refs.wrap
      scrollValue.value = wrap.scrollLeft 
    }
    onMounted(()=>{
      const wrap = scrollRef.value.elScrollbarRef.$refs.wrap
      wrap.addEventListener("scroll", scroll)
    })
    onUnmounted(()=>{
      const wrap = scrollRef.value.elScrollbarRef.$refs.wrap
      wrap.removeEventListener("scroll", scroll)
    })
    return {
      checkedStyle,
      scrollRef,
      changeCurrentPic,
      scrollByClick,
      scroll
    }
  }
})
